// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"M1-z","dimensionLabel":"N1-z","styleChooserControlWrapper":"O1-z","styleChooserControl":"P1-z","disabled":"Q1-z","giftCard":"R1-z","styleChooserText":"S1-z"};